<template>
  <v-dialog
    :model-value="modelValue"           
    max-width="600"
  >
    <v-card>
      <v-card-title class="modal-header">
        Annotation Set Info
      </v-card-title>

      <v-container class="modal-main">
        <template  v-for="a in annsetSummary" :key="a">
          <hr v-if="a.label=='-'">
          <v-row no-gutters v-else-if="a.label=='UID'">
            <v-col cols="4" class="label">{{ a.label }}</v-col>
            <v-col cols="8">
              <EncodedIdField 
                :id="a.val"
                :type="'annotation set'"/>
              </v-col>
            </v-row>
          <v-row no-gutters v-else>
            <v-col cols="4" class="label">{{a.label }}</v-col>
            <v-col cols="8">{{ a.val }}</v-col>
          </v-row>
        </template>

          <div v-if="countsLoaded">
            <template  v-for="a in annsetCounts" :key="a">
              <hr v-if="a.label=='-'">
              <v-row no-gutters v-else-if="a.label=='UID'">
                <v-col cols="4" class="label">{{ a.label }}</v-col>
                <v-col cols="8">
                  <EncodedIdField 
                    :id="a.val"
                    :type="'annotation set'"/>
                  </v-col>
                </v-row>
              <v-row no-gutters v-else>
                <v-col cols="4" class="label">{{a.label }}</v-col>
                <v-col cols="8">{{ a.val }}</v-col>
              </v-row>
            </template>
          </div>
          <div v-else>
            <div class="center"><div class="lds-ring"><div /><div /><div /><div /></div></div>
          </div>
      </v-container>


      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)" class="button">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import EncodedIdField from '@/components/EncodedIdField.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { ref, watch, onMounted } from 'vue';

const be = new DatastoreConnect();
const showDialog = ref(false);

const props = defineProps({
  modelValue: Boolean, // for v-model
  annotationSet: Object,
});

const annsetSummary=ref([]);
const annsetCounts=ref([]);
const countsLoaded=ref(false);

function humanizeDateIfValid(date) {
  if (!date) return "";

  const d = new Date(date);
  if (d.getFullYear() <= 2000) return "";

  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',   // Jan, Feb, Mar...
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

async function loadCounts() {
  annsetCounts.value=[];
  countsLoaded.value=false;


  const ret = await be.api('annset.counts',{ annotation_set_id: props.annotationSet.id})
  if(ret.result){
    const ann=ret.result;
    annsetCounts.value.push({label:'Annotations Count:',val:''});
    annsetCounts.value.push({label:'Images with Annotations',val:ann.num_images});
    annsetCounts.value.push({label:'Total',val:ann.num_annotations});
    annsetCounts.value.push({label:'3D Boxes',val:ann.num_3dbox});
    annsetCounts.value.push({label:'2D Boxes',val:ann.num_2dbox});
    annsetCounts.value.push({label:'Segmentations',val:ann.num_seg});

    annsetCounts.value.push({label:'-'});
    annsetCounts.value.push({label:'Sensors Count:',val:''});

    if (ann.num_sensors) {
      for (const s of ann?.num_sensors ?? []) {
        annsetCounts.value.push({label:s.type,val:s.count});
      }
    }
  }
  if(ret.error) {
    annsetCounts.value.push({label:'Error:',val:ret.error.message});
  }
  
  countsLoaded.value=true;
}


watch(
  () => props.annotationSet,
  (ann) => {
    annsetSummary.value = [];
    if (!ann) {return}

    annsetSummary.value.push({label:'Name', val:ann.name});
    annsetSummary.value.push({label:'UID',val:ann.id});
    annsetSummary.value.push({label:'ID',val:ann.id});
    annsetSummary.value.push({label:'Date',val: humanizeDateIfValid(ann.date)});
    annsetSummary.value.push({label:'Owner',val:ann.owner});
    annsetSummary.value.push({label:'-'});
  },
  { immediate: true } // optional, runs watcher immediately on setup
);

watch(
  () => props.modelValue,
  async (isOpen) => {
    if (isOpen && props.annotationSet) {
      await loadCounts();
    }
  }
);

const emit = defineEmits(['update:modelValue']);
</script>

.label {
   width: 50px; 
   font-weight: 500;
}

.value {

}

v-row {
  margin:0px;
}

<style lang="scss" scoped>
.settings {
  padding: 0.75rem 3rem;
  min-width: 420px;
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

</style>
